import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SIMPLE_COURSE_CARD_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, SIMPLE_COURSE_CARD_TRANSLATION_KEY, {
  SCC_COURSE_DETAIL: 'Detalhes do curso',
  SCC_ENROLL_NOW: 'Inscreva-se agora',
  SCC_ENROLL_FREE: 'Inscreva-se gratuitamente!',
  SCC_GO_TO_CLASSROOM: 'Ir para o curso',
  SCC_BY: 'Por',
  SCC_STUDENTS: 'alunos',
  SCC_WATCH_TRAILER: 'Ver Trailer',
  SCC_BOOKMARK_TITLE: 'Salvar curso'
});